import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServerRootService } from '@se/se.ui.html5';
import { Store } from '@ngrx/store';

import { seReportDeleteKeyImages } from '../../../report/report.actions';
import {
    seViewerKeyImagesSet,
    seViewerKeyImagesPerRows,
} from '../../../root-store/root.actions';
import { KeyImage } from '../../../services/imaging/common';
import { ISeSideKeyObject, SeSideImagesType } from './se-side-key-images-models';

@Injectable({
    providedIn: 'root',
})
export class KeyImagesService extends ServerRootService {
    private readonly baseUrl = this.getServerRoot() + '/ClinicalRepository';

    constructor(private http: HttpClient, private store: Store) {
        super();
    }

    getKeyImages(keyData: ISeSideKeyObject[]): Observable<SeSideImagesType[]> {
        const keyImages: ISeSideKeyObject[] = keyData.filter(
            (k) => !!k.IdExamination && !!k.RepositoryKey && !!k.SOPInstanceUID,
        );

        return this.http.post<SeSideImagesType[]>(`${this.baseUrl}/GetKeyImages`, { keyImages }, this.buildOptions());
    }

    deleteKeyImages(repositoryKeys: string[]): Observable<unknown> {
        const keyImages = repositoryKeys.map((repositoryKey) => ({ repositoryKey }));

        return this.http.post<SeSideImagesType[]>(
            `${this.baseUrl}/DeleteKeyImages`,
            { keyImages },
            this.buildOptions(),
        );
    }

    saveKeyImagesData(data: KeyImage[]) {
        this.store.dispatch(seViewerKeyImagesSet({ images: data }));
    }

    requestKeyImageDeletion(data: KeyImage) {
        this.store.dispatch(seReportDeleteKeyImages({ keyImages: [data] }));
    }

    requestAllKeyImagesDeletion(data: KeyImage[]) {
        const imagesToBeDeleted = data.filter((k) => k.IsDeletable);

        this.store.dispatch(seReportDeleteKeyImages({ keyImages: imagesToBeDeleted }));
    }

    saveRowValue(data: number) {
        this.store.dispatch(seViewerKeyImagesPerRows({ rows: data }));
    }
}
